import { onMounted, onBeforeUnmount } from 'vue';

export function useClickOutside(component, callback) {
  if (!component) return;

  const listener = (event) => {
    if (event.target.closest('.menu__item')) {
      return;
    }

    if (component.value.contains(event.target)) {
      callback();
    }
  };

  onMounted(() => {
    document.addEventListener('click', listener);
  });
  onBeforeUnmount(() => {
    document.removeEventListener('click', listener);
  });
}
